import { Fragment } from "react";
import SenderDetails from "../SenderDetails";
import ReceiverDetails from "../ReceiverDetails";
import ParcelInfo from "../ParcelPoint/ParcelInfo";

const LockerForm = ({ type }) => {
    return <Fragment>
        <SenderDetails />
        <div style={{ margin: "3vh" }} />
        {(type.includes('pp_')) && (<ParcelInfo type={type }/>)}
        <div style={{ margin: "3vh" }} />
        <ReceiverDetails type={type}/>

    </Fragment>
}

export default LockerForm;